import { render } from "./SystemLogsErrors.vue?vue&type=template&id=4a97ccfe&scoped=true"
import script from "./SystemLogsErrors.vue?vue&type=script&lang=js"
export * from "./SystemLogsErrors.vue?vue&type=script&lang=js"

import "./SystemLogsErrors.vue?vue&type=style&index=0&id=4a97ccfe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a97ccfe"]])

export default __exports__